import React, { use, useEffect, useLayoutEffect, useRef, useState } from 'react'
import { useDispatch } from 'react-redux'

function Input ({
  type = 'text',
  label,
  fieldName,
  searchFieldName,
  placeholder = '',
  eventHandler = null,
  dataset = {},
  data = [],
  requestParams = {},
  dataSource = null,
  col = null,
  disabled = false,
  readonly = false,
  defaultChecked = false,
  disableSelectOptions = false,
  defaultSelectOptions = [], //[{value:'',text:'Seçin...'}],
  disableByValue = null,
  required = false,
  multiple = false,
  acceptFileFormats = {},
  acceptImageFormats = 'image/*',
  value = null,
  className = '',
  style = {},
  validationResult = null
}) {
  //configure input position in form
  let columnClassName = ''

  if (col) {
    Object.keys(col).forEach(key => {
      if (col[key] != 0) {
        columnClassName +=
          key == 'default' ? ' col-' + col[key] : ' col-' + key + '-' + col[key]
      } else {
        columnClassName += key == 'default' ? ' d-none' : ' d-none'
      }
    })
  }

  const [uid, setUid] = useState('')
  //input type file -image
  const [images, setImages] = useState(type == 'image' ? data : [])
  const [files, setFiles] = useState(type == 'image' ? data : [])
  const [currentIndex, setCurrentIndex] = useState(0)
  const [currentValue, setCurrentValue] = useState(value)
  const [selectListData, setSelectListData] = useState(
    defaultSelectOptions.concat(data)
  )
  const [loading, setLoading] = useState(false)
  const [errorState, setErrorState] = useState({})
  const inputRef = useRef(null)
  const warningRef = useRef(null)
  const previewRef = useRef(null)
  const [draggedItem, setDraggedItem] = useState(null)
  const imgRef = useRef(null)
  const parentRef = useRef(null)

  useEffect(() => {
    let uid = window.crypto.randomUUID().split('-')[0]
    setUid(uid)
  }, [])

  useEffect(() => {
    setErrorState(validationResult)
  }, [validationResult])

  useEffect(() => {
    if (type !== 'image') {
      inputRef.current?.addEventListener('focus', () => {
        if (errorState) {
          setErrorState(null)
        }
      })

      if (inputRef.current && dataset && Object.keys(dataset)) {
        Object.keys(dataset).forEach(k => {
          inputRef.current.dataset[k] = dataset[k]
        })
      }

      if (eventHandler) {
        let _element = inputRef.current
        if (eventHandler.length) {
          eventHandler.forEach(handler => {
            _element?.removeEventListener(handler.type, handler.handler)
            _element?.addEventListener(handler.type, handler.handler)
          })
        } else {
          _element?.removeEventListener(eventHandler.type, eventHandler.handler)
          _element?.addEventListener(eventHandler.type, eventHandler.handler)
        }
      }
    }
  }, [])

  useEffect(() => {
    if (
      ['date', 'text', 'time', 'number', 'select', 'checkbox'].includes(type)
    ) {
      setCurrentValue(value)
    }
    if (type === 'select-multiple') {
      setCurrentValue(value?.split(','))
    }
    if (
      ['select','select-multiple'].includes(type) && 
      !([null,undefined].includes(dataSource))
    ) {
      getData({})
    }if(type==='select-searchable'){
      let call = dataSource(Object.assign(requestParams,{[fieldName]:value}))
      call.then(response=>{
        if(value==null){
            inputRef.current.value=null
        }else{
            inputRef.current.value=response?.[0]?.['text']
        }
      })
    }
  }, [value])

  useEffect(()=>{
    if (
      (type === 'select' || type === 'select-multiple') &&
      data?.length > 0
    ) {
      setSelectListData(defaultSelectOptions.concat(data))
    }
  },[data])

  const getData = async parameters => {
    setLoading(true)
    let listData = await dataSource(parameters)
    setSelectListData(defaultSelectOptions.concat(listData))
    setLoading(false)
  }

  const renderInputBox = () => {
    switch (type) {
      case 'textarea':
        return (
          <div
            className={`input-box${disabled ? ' disabled' : ''}`}
            data-type={type}
          >
            <label htmlFor={uid}>
              {label}
              {required ? <span className='required'>*</span> : ''}
            </label>
            <textarea
              //required={required}
              autoComplete='off'
              id={uid}
              ref={inputRef}
              defaultValue={value}
              name={fieldName}
              className={className}
              placeholder={placeholder}
            ></textarea>
            <span
              ref={warningRef}
              className='warning-message'
              htmlFor={fieldName}
            ></span>
          </div>
        )
      case 'select':
        return (
          <div
            className={`input-box${disabled ? ' disabled' : ''}`}
            data-type={type}
          >
            <label htmlFor={uid}>
              {label}
              {required ? <span className='required'>*</span> : ''}
            </label>
            {selectListData && (
              <select
                id={uid}
                name={fieldName}
                className={className}
                ref={inputRef}
                disabled={
                  disabled ||
                  (defaultSelectOptions?.length == 0 &&
                    selectListData?.length == 0)
                }
                value={currentValue ?? ''}
                onChange={e => {
                  setCurrentValue(e.target.value)
                }}
                placeholder={placeholder}
              >
                {loading && <option>Yüklənir...</option>}
                {selectListData?.map((option,idx) => {
                  return (
                    <option
                      disabled={disableSelectOptions && !option[disableByValue]}
                      key={`${option?.text}#${option?.value}#${idx}`}
                      value={option?.value}
                    >
                      {option?.text}
                    </option>
                  )
                })}
                {!loading &&
                  defaultSelectOptions?.length == 0 &&
                  selectListData?.length == 0 && (
                    <option disabled={true} key={``} value={''}>
                      {'Seçim yoxdur...'}
                    </option>
                  )}
              </select>
            )}
            <span
              ref={warningRef}
              className='warning-message'
              htmlFor={fieldName}
            ></span>
          </div>
        )
      case 'select-multiple':
        return (
          <div
            className={`input-box${disabled ? ' disabled' : ''}`}
            data-type={type}
          >
            <label htmlFor={uid}>
              {label}
              {required ? <span className='required'>*</span> : ''}
            </label>
            {selectListData && (
              <select
                id={uid}
                name={fieldName}
                multiple
                className={className}
                ref={inputRef}
                disabled={
                  disabled ||
                  (defaultSelectOptions?.length == 0 &&
                    selectListData?.length == 0)
                }
                value={currentValue || []}
                onChange={e => {
                  setCurrentValue(
                    Array.from(e.target.selectedOptions).map(o => o.value)
                  )
                }}
                onMouseDown={e => {
                  if (e.target.localName == 'option') {
                    e.preventDefault()
                    e.target.selected = !e.target.selected
                  }
                }}
                placeholder={placeholder}
              >
                {loading && <option>Yüklənir...</option>}
                {selectListData?.map(option => {
                  return (
                    <option
                      disabled={disableSelectOptions && !option[disableByValue]}
                      key={`${option?.text}#${option?.value}`}
                      value={option?.value}
                    >
                      {option?.text}
                    </option>
                  )
                })}
                {!loading &&
                  defaultSelectOptions?.length == 0 &&
                  selectListData?.length == 0 && (
                    <option disabled={true} key={``} value={''}>
                      {'Seçim yoxdur...'}
                    </option>
                  )}
              </select>
            )}
            <span
              ref={warningRef}
              className='warning-message'
              htmlFor={fieldName}
            ></span>
          </div>
        )
      case 'select-searchable':
        return (
          <div
            className={`input-box${disabled ? ' disabled' : ''}`}
            style={selectListData.length>0?{zIndex:1}:{zIndex:0}}
            data-type={type}
          >
            <label htmlFor={uid}>
              {label}
              {required ? <span className='required'>*</span> : ''}
            </label>
            <input
              id={uid}
              type='hidden'
              value={currentValue || ''}
              onChange={() => {}}
              name={fieldName}
            />
            <input
              id={'_' + uid}
              type='text'
              placeholder={placeholder}
              autoComplete='off'
              name={searchFieldName}
              ref={inputRef}
              disabled={currentValue!=null}
              onChange={async e => {
                return await getData(Object.assign(requestParams,{ [searchFieldName]: e.target.value }))
              }}
              onBlur={e => setSelectListData([])}
              onFocus={async e => await getData(Object.assign(requestParams,{ [searchFieldName]: e.target.value }))}
            />
            <ul className='select-searchable-list' style={{}}>
              {selectListData?.map(option => {
                return (
                  <li
                    className={'option'}
                    key={`${option?.text}#${option?.value}`}
                    data-value={option?.value}
                    onMouseDown={e => {
                      e.preventDefault()
                      inputRef.current.value = option?.text
                      setCurrentValue(e.target.dataset['value'])
                      setSelectListData([])
                    }}
                  >
                    {option?.text}
                  </li>
                )
              })}
            </ul>
            <span
              ref={warningRef}
              className='warning-message'
              htmlFor={fieldName}
            ></span>
          </div>
        )
      case 'checkbox':
        return (
          <div
            className={`input-box${disabled ? ' disabled' : ''}`}
            data-type={type}
          >
            <input
              type={type}
              ref={inputRef}
              name={fieldName}
              id={uid}
              disabled={disabled}
              checked={currentValue == 1 ? true : false}
              value={currentValue}
              onChange={e => setCurrentValue(e.target.checked ? 1 : 0)}
              className={className}
              style={style}
              autoComplete='off'
            />
            <label htmlFor={uid}>
              {label}
              {required ? <span className='required'>*</span> : ''}
            </label>
            <span
              ref={warningRef}
              className='warning-message'
              htmlFor={fieldName}
            ></span>
          </div>
        )
      case 'image':
        return (
          <div
            className={`input-box${disabled ? ' disabled' : ''}`}
            data-type={type}
          >
            <label htmlFor={uid}>{label}</label>
            <div className='input-image-wrapper'>
              <div className='add-image'>
                <input
                  type={'file'}
                  id={uid}
                  name={fieldName}
                  ref={inputRef}
                  disabled={disabled}
                  multiple={multiple}
                  accept={acceptImageFormats}
                  onChange={previewPhoto}
                  data-value={images}
                  className={className}
                />
              </div>
              <div
                className='zoom-image'
                ref={previewRef}
                data-currentindex={0}
              >
                <img />
                <div className='close-image' onClick={closeImage}>
                  &times;
                </div>
                <div
                  className='slide-button previous'
                  onClick={() => {
                    slideImage(-1)
                  }}
                >
                  &#8249;
                </div>
                <div
                  className='slide-button next'
                  onClick={() => {
                    slideImage(1)
                  }}
                >
                  &#8250;
                </div>
              </div>
              <div className='input-images' ref={parentRef}>
                {!loading &&
                  [...images].length > 0 &&
                  [...images].map((image, index) => {
                    return (
                      <div
                        key={index}
                        className='input-image'
                        ref={imgRef}
                        data-draggable='true'
                        onDrag={e => {
                          setDraggedItem(e.target.closest('.input-image'))
                        }}
                        onDragStart={e => {}}
                        onDragEnd={e => {
                          setDraggedItem(null)
                        }}
                        onDragOver={e => {
                          e.preventDefault()
                        }}
                        onDrop={e => {
                          e.preventDefault()
                          image = e.target.closest('.input-image')
                          let parent = parentRef.current
                          parent.insertBefore(draggedItem, image)
                        }}
                      >
                        <div className='remove'>
                          <button
                            type='button'
                            data-index={index}
                            className='remove-button'
                            onClick={removeImage}
                          >
                            &times;
                          </button>
                        </div>
                        <img
                          className='image-preview'
                          name={`input-image-preview${multiple ? '[]' : ''}`}
                          src={image.src}
                          data-base64={image.base64}
                          data-srclarge={image.srclarge}
                          data-imageurl={image.imageurl}
                          data-order={image.order}
                          data-isnew={image.isNew}
                          //data-value={JSON.stringify(image)}
                          onClick={zoomImage}
                        />
                      </div>
                    )
                  })}
              </div>
            </div>
          </div>
        )
      case 'file':
        return (
          <div
            className={`input-box${disabled ? ' disabled' : ''}`}
            data-type={type}
          >
            <label htmlFor={uid}>
              {label}
              {required ? <span className='required'>*</span> : ''}
            </label>
            <input
              type={'file'}
              ref={inputRef}
              name={fieldName}
              id={uid}
              disabled={disabled}
              className={className}
              onChange={getBase64}
              multiple={multiple}
              data-value={null}
              style={style}
              accept={acceptFileFormats}
              autoComplete='off'
            />
            <span
              ref={warningRef}
              className='warning-message'
              htmlFor={fieldName}
            ></span>
          </div>
        )
      case 'button':
      case 'submit':
        return (
          <div
            className={`input-box${disabled ? ' disabled' : ''}`}
            data-type={type}
          >
            <input
              type={type}
              id={uid}
              ref={inputRef}
              disabled={disabled}
              className={className}
              name={fieldName}
              style={style}
              noValidate
              value={label}
            />
            <span
              ref={warningRef}
              className='warning-message'
              htmlFor={fieldName}
            ></span>
          </div>
        )
      case 'time':
        return (
          <div
            className={`input-box${disabled ? ' disabled' : ''}`}
            data-type={type}
          >
            <label htmlFor={uid}>
              {label}
              {required ? <span className='required'>*</span> : ''}
            </label>
            <input
              type={type}
              //required={required}
              id={uid}
              ref={inputRef}
              name={fieldName}
              step={60}
              disabled={disabled}
              placeholder={placeholder}
              readOnly={readonly}
              value={currentValue == null ? '' : currentValue}
              onChange={e => {
                setCurrentValue(e.target.value)
              }}
              className={className}
              style={style}
              autoComplete='off'
              noValidate
            />
            <span
              ref={warningRef}
              className={`warning-message${
                errorState?.result == false ? ' show' : ''
              }`}
              htmlFor={fieldName}
            >
              {errorState?.message}
            </span>
          </div>
        )
      case 'date':
        return (
          <div
            className={`input-box${disabled ? ' disabled' : ''}`}
            data-type={type}
          >
            <label htmlFor={uid}>
              {label}
              {required ? <span className='required'>*</span> : ''}
            </label>
            <input
              type={'date'}
              //required={required}
              id={uid}
              ref={inputRef}
              name={fieldName}
              disabled={disabled}
              placeholder={placeholder}
              readOnly={readonly}
              value={currentValue || ''}
              onChange={e => {
                setCurrentValue(e.target.value)
              }}
              className={className}
              style={style}
              noValidate
            />
            <span
              ref={warningRef}
              className={`warning-message${
                errorState?.result == false ? ' show' : ''
              }`}
              htmlFor={fieldName}
            >
              {errorState?.message}
            </span>
          </div>
        )
      case 'readonly-text':
        return (
          <div
            className={`input-box${disabled ? ' disabled' : ''}`}
            data-type={type}
          >
            <label>{label}</label>
            <p
              id={uid}
              name={fieldName}
              className={className}
              style={{
                fontWeight: '500'
              }}
            >
              {[null, undefined, ''].includes(value) ? '-' : value}
            </p>
          </div>
        )
      case 'hidden':
        return (
          <input
            type={type}
            //required={required}
            id={uid}
            ref={inputRef}
            defaultValue={value}
            name={fieldName}
          />
        )
      case 'number':
        return (
          <div
            className={`input-box${disabled ? ' disabled' : ''}`}
            data-type={type}
          >
            <label htmlFor={uid}>
              {label}
              {required ? <span className='required'>*</span> : ''}
            </label>
            <input
              type={type}
              //required={required}
              id={uid}
              autoComplete='off'
              ref={inputRef}
              name={fieldName}
              disabled={disabled}
              value={currentValue || ''}
              onChange={e => setCurrentValue(e.target.value)}
              placeholder={placeholder}
              className={className}
              style={{ ...style }}
              noValidate
              //ValidateInput(validateAs)
            />
            <span
              ref={warningRef}
              className={`warning-message${
                errorState?.result == false ? ' show' : ''
              }`}
              htmlFor={fieldName}
            >
              {errorState?.message}
            </span>
          </div>
        )
      case 'text':
        return (
          <div
            className={`input-box${disabled ? ' disabled' : ''}`}
            data-type={type}
          >
            <label htmlFor={uid}>
              {label}
              {required ? <span className='required'>*</span> : ''}
            </label>
            <input
              type={'text'}
              //required={required}
              id={uid}
              ref={inputRef}
              autoComplete='off'
              name={fieldName}
              disabled={disabled}
              value={currentValue || ''}
              onChange={e => setCurrentValue(e.target.value)}
              className={className}
              style={style}
            />
            <span
              ref={warningRef}
              className={`warning-message${
                errorState?.result == false ? ' show' : ''
              }`}
              htmlFor={fieldName}
            >
              {errorState?.message}
            </span>
          </div>
        )
      default:
        return (
          <div
            className={`input-box${disabled ? ' disabled' : ''}`}
            data-type={type}
          >
            <label htmlFor={uid}>
              {label}
              {required ? <span className='required'>*</span> : ''}
            </label>
            <input
              type={type}
              //required={required}
              id={uid}
              autoComplete='off'
              ref={inputRef}
              name={fieldName}
              disabled={disabled}
              defaultValue={currentValue}
              className={className}
              style={style}
            />
            <span
              ref={warningRef}
              className={`warning-message${
                errorState?.result == false ? ' show' : ''
              }`}
              htmlFor={fieldName}
            >
              {errorState?.message}
            </span>
          </div>
        )
    }
  }

  const getBase64 = e => {
    setLoading(true)
    let fileList = Array.from(e.target.files)
    let fileReader = null
    let _files = multiple ? [...files] : []
    if (fileList.length > 0) {
      fileList.forEach(file => {
        let _file
        fileReader = new FileReader()
        fileReader.readAsDataURL(file)
        fileReader.onloadend = ev => {
          _file = {
            base64: ev.target.result,
            name: file.name,
            order: [...files].length + 1,
            size: file.size,
            type: file.type,
            isNew: true,
            src: URL.createObjectURL(file)
          }
          e.target.dataset['value'] = ev.target.result
          _files.push(_file)
          setFiles(_files)
        }
      })
    }
    setLoading(false)
  }

  const previewPhoto = e => {
    setLoading(true)
    let fileList = Array.from(e.target.files)
    let fileReader = null
    if (fileList.length > 0) {
      fileList.forEach(image => {
        let _image
        fileReader = new FileReader()
        fileReader.readAsDataURL(image)
        let _images = [...images]

        fileReader.onloadend = ev => {
          _image = {
            base64: ev.target.result,
            name: image.name,
            order: [...images].length + 1,
            size: image.size,
            type: image.type,
            isNew: true,
            src: URL.createObjectURL(image)
          }
          if (!multiple) {
            _images = []
          }
          _images.push(_image)
          setImages(_images)
        }
      })
    }
    e.target.value = null
    setLoading(false)
  }

  const removeImage = e => {
    let _idx = e.target.dataset['index']
    let imagesArray = [...images]
    imagesArray.splice(_idx, 1)
    imagesArray.map((i, index) => {
      i.order = index + 1
    })
    setImages(imagesArray)
  }

  const zoomImage = e => {
    let _imageWindow = previewRef.current
    _imageWindow.style.display = 'block'
    document.getElementsByTagName('body')[0].style.overflow = 'hidden'
    _imageWindow.querySelector('img').src = e.target.dataset.srclarge
  }

  const closeImage = e => {
    let _imageWindow = previewRef.current
    _imageWindow.style.display = 'none'
    document.getElementsByTagName('body')[0].style.overflow = 'auto'
  }

  const slideImage = index => {
    let nextIndex = currentIndex + index

    let _imageList = [...images]
    if (nextIndex < 0) {
      nextIndex = _imageList.length - 1
    } else if (nextIndex > _imageList.length - 1) {
      nextIndex = 0
    }
    setCurrentIndex(nextIndex)
    let _imageWindow = previewRef.current
    _imageWindow.querySelector('img').src = _imageList[nextIndex].srclarge
  }

  if(columnClassName) return <div className={columnClassName}>{renderInputBox()}</div>
  else return renderInputBox()
}

export default Input
